<template>
    <component
        :is="component"
        :to="toComputed"
        :href="href"
        :disabled="disabled"
        :target="target"
        class="ax-road-button"
        :class="{
            [`ax-road-button--size-${size}`]: true,
            [`ax-road-button--variant-${variant}`]: true,
            'ax-road-button--block': block,
        }"
        @click="$emit('click', $event)"
    >
        <slot />
    </component>
</template>

<script>
export default {
    name: 'AxRoadButton',
    props: {
        to: {
            type: [String, Object],
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'small',
            validator: value => {
                return ['small', 'large'].includes(value)
            },
        },
        variant: {
            type: String,
            default: 'solid',
            validator: value => {
                return ['solid', 'outline', 'dark'].includes(value)
            },
        },
        block: {
            type: Boolean,
            default: false,
        },
        target: {
            type: String,
            default: '_self',
            validator: value => {
                return ['_self', '_blank'].includes(value)
            },
        },
    },
    computed: {
        component() {
            if (this.to) {
                return this.to.toString().startsWith('http')
                    ? 'a'
                    : 'router-link'
            } else {
                return 'button'
            }
        },
        toComputed() {
            if (this.to && typeof this.to === 'object') {
                return this.to
            } else if (this.to && typeof this.to === 'string') {
                return { path: this.to }
            } else {
                return null
            }
        },
        href() {
            return this.to && typeof this.to === 'string' ? this.to : null
        },
    },
}
</script>

<style lang="scss">
.ax-road-button {
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    color: $color-text;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    cursor: pointer;

    &--block {
        width: 100%;
    }

    &--size-small {
        padding: 5px 12px;
    }

    &--size-large {
        padding: 12px;
    }

    &--variant-solid {
        background-color: $color-pill-blue-light;
        border: none;

        &:hover {
            background-color: darken($color-pill-blue-light, 2%);
        }
    }

    &--variant-dark {
        background-color: $color-blue-dark;
        border: none;
        color: $color-primary-contrast;

        &:hover {
            background-color: lighten($color-blue-dark, 5%);
        }
    }

    &--variant-outline {
        background-color: transparent;
        border: 1px solid $color-blue-dark;

        &:hover {
            background-color: $color-pill-blue-light;
        }
    }
}
</style>
